import { Networker } from '@idp/networker';
import LocationProvider from '@idp/business-features/LocationProvider';
// const oneMapApi = '/apis/maps/v2/locator/search/latlon';
var oneMapApi = '/msapi/onemap/v2/locator/search/latlon';
var searchCookie = 'attPersistantLocalization';
var itemInCookie = 'zip';
/**
 * function check if zip is present or not in cookie
 */
export var isCookiePresent = function (cookieName) {
    var promise = new Promise(function (resolve, reject) {
        if (cookieName !== undefined && cookieName !== null) {
            var decodedCookie = decodeURIComponent(document.cookie);
            var cookieArry = decodedCookie.split(';');
            consoleLogMsg(' cookieArry  ---- >' + cookieArry);
            var isCookie = false;
            for (var _i = 0, cookieArry_1 = cookieArry; _i < cookieArry_1.length; _i++) {
                var cookie = cookieArry_1[_i];
                if (cookie.includes(cookieName)) {
                    isCookie = true;
                    var val = cookie.split(cookieName + '=')[1];
                    resolve({ cName: cookieName, cValue: val });
                    break;
                }
            }
            if (!isCookie) {
                reject(false);
            }
        }
        else {
            reject(false);
        }
    });
    return promise;
};
export var checkAndSetZipCode = function () {
    var cookieObj = {
        cName: '',
        cValue: '',
        needtoSet: '',
    };
    var resolve = function (cBoj) {
        consoleLogMsg(' cookie already present ---- >> ' + cBoj.cName + ' :: ' + cBoj.cValue);
        cookieObj = {
            cName: cBoj.cName,
            cValue: cBoj.cValue,
            needtoSet: itemInCookie,
        };
        if (cBoj.cValue.indexOf(itemInCookie + '=') === -1) {
            getZipCodeValue(cookieObj);
        }
    };
    var reject = function (error) {
        consoleLogMsg(' Cookie not present error ---- >> ' + error);
        cookieObj = {
            cName: searchCookie,
            cValue: '',
            needtoSet: itemInCookie,
        };
        getZipCodeValue(cookieObj);
    };
    isCookiePresent(searchCookie).then(resolve, reject);
};
var getZipCodeValue = function (param) {
    var callOneMapAPI = function (location) {
        if (location.error) {
            setAlternateZipcode(param);
        }
        if ((location.latitude !== null && location.latitude !== undefined) &&
            (location.longitude !== null && location.longitude !== undefined)) {
            consoleLogMsg('callingBingAPI ' + location.latitude + ',' + location.longitude);
            /*const url = oneMapApi + '?origin=' + location.latitude + ',' + location.longitude + '&radius=10';
            const networker = new Networker();
            networker.get(url)
            .then( (response) => {
                return response.json();
            })
            .then ((data) => {
                if (data.place !== null && data.place !== undefined ) {
                    let zipCodes = [];
                    if (!Array.isArray(data.place)) {
                        zipCodes = Array.from(data.place);
                    } else {
                        zipCodes = data.place;
                    }
                    const zipCode = zipCodes.find((i: {postal: string}) => i.postal != null).postal.substring(0, 5);
                    if (zipCode != null) {
                        setZipCodeValue(param, zipCode);
                    } else {
                        setAlternateZipcode(param);
                    }
                } else {
                    console.error('OneMap did not return place []');
                    setAlternateZipcode(param);
                }
            })
            .catch((error) => {
                setAlternateZipcode(param);
                consoleLogMsg(' catch error ' + error);
            });*/
            var networker = new Networker();
            fetch("https://dev.virtualearth.net/REST/v1/Locations/" + location.latitude + "," + location.longitude + "?" +
                "output=json&key=Akg_FZYIXiJc8S0ZecryN60DVoNKcHsd8fNm89pSSshPe_R4y89aoVQB8tBK02zt", {
                method: 'GET',
            })
                .then(function (response) { return response.json(); })
                .then(function (json) {
                var zipCode = json.resourceSets[0].resources[0].address.postalCode;
                if (zipCode != null) {
                    setZipCodeValue(param, zipCode);
                }
                else {
                    setAlternateZipcode(param);
                }
            })
                .catch(function (reason) {
                console.log('Bing api error:', reason);
                setAlternateZipcode(param);
            });
        }
    };
    LocationProvider.getLocation(callOneMapAPI);
};
function setAlternateZipcode(cookieObj) {
    new Networker()
        .get('/msapi/wirelessorder/v1/akamaiheader/getzipcode')
        .then(function (response) {
        return response.json();
    })
        .then(function (data) {
        if (data.zip) {
            setZipCodeValue(cookieObj, data.zip);
        }
    })
        .catch(function (error) {
        consoleLogMsg(' catch error ' + error);
    });
}
function setZipCodeValue(coockieObj, zipcode) {
    if (coockieObj.cName !== undefined && coockieObj.cName !== null
        && coockieObj.needtoSet !== undefined && coockieObj.needtoSet !== null) {
        if (coockieObj.cValue === undefined || coockieObj.cValue === null || coockieObj.cValue === '') {
            document.cookie = coockieObj.cName + '=' + coockieObj.needtoSet + '=' + zipcode + ';path=/';
            consoleLogMsg(' setZipCodeValue  if   ' + coockieObj.cName + '=' + coockieObj.needtoSet + '=' + zipcode + ';path=/');
        }
        else {
            document.cookie = coockieObj.cName + '=' + coockieObj.cValue + '|' + coockieObj.needtoSet + '=' + zipcode + ';path=/';
            consoleLogMsg(' setZipCodeValue  else   ' + coockieObj.cName + '=' + coockieObj.cValue + '|' + coockieObj.needtoSet + '=' + zipcode + +';path=/');
        }
    }
}
function consoleLogMsg(msg) {
    // console.log(' consoleLogMsg  ashutosh >>>>>>  ' + msg);
}
export default { isCookiePresent: isCookiePresent, checkAndSetZipCode: checkAndSetZipCode };
//# sourceMappingURL=zip-code-provider.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/services/zip-code-provider.js
// module id = 1473
// module chunks = 8